import api from '@/apis'

export default {
  state: {
    visibility: false,
    role_list: [
      { text: 'Super Admin', value: 4 },
      { text: 'Admin', value: 2 },
      { text: 'User', value: 1 }
    ],
    table: {
      loading: false,
      role_loading: false,
      role_loading_id: null,
      group_loading: false,
      group_loading_id: null,
      search: '',
      options: { page: 1 },
      total_items: 4,
      headers: [
        { text: 'Username', value: 'username', width: 127 },
        { text: 'Display Name', value: 'display_name', width: 133 },
        { text: 'Email Address', value: 'email', width: 187 },
        { text: 'Role', value: 'role', width: 122 },
        { text: 'Group', value: 'group', width: 144 },
        { text: '', value: 'action', sortable: false, width: 68 }
      ],
      items: []
    }
  },
  mutations: {
    RESET_USER_MANAGEMENT_DIALOG(state) {
      state.visibility = false
      state.table.search = ''
    },
    SET_USER_MANAGEMENT_DIALOG_VISIBILITY(state, payload) {
      state.visibility = payload
    },
    SET_USER_MANAGEMENT_DIALOG_TABLE_LOADING(state, payload) {
      state.table.loading = payload
    },
    SET_USER_MANAGEMENT_DIALOG_TABLE_SEARCH(state, payload) {
      state.table.search = payload
    },
    SET_USER_MANAGEMENT_DIALOG_TABLE_OPTIONS(state, payload) {
      state.table.options = payload
    },
    SET_USER_MANAGEMENT_DIALOG_TABLE_TOTAL_ITEMS(state, payload) {
      state.table.total_items = payload
    },
    SET_USER_MANAGEMENT_DIALOG_TABLE_ITEMS(state, payload) {
      state.table.items = payload
    }
  },
  actions: {
    async fetchUserManagementList({ state, commit }) {
      try {
        commit('SET_USER_MANAGEMENT_DIALOG_TABLE_LOADING', true)

        const { page, itemsPerPage } = state.table.options
        const response = await api.getUserList({ limit: itemsPerPage, offset: page * itemsPerPage - itemsPerPage, search: state.table.search })
        if (response.data.success) {
          commit('SET_USER_MANAGEMENT_DIALOG_TABLE_ITEMS', response.data.data)
          commit('SET_USER_MANAGEMENT_DIALOG_TABLE_TOTAL_ITEMS', response.data.total)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_USER_MANAGEMENT_DIALOG_TABLE_LOADING', false)
      }
    },
    async updateUser({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Updating User', loading: true })

        const response = await api.updateUser({ params: payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        dispatch('fetchUserManagementList')
      }
    }
  }
}
